import { MathToFixed } from '../../../components/Utils';
import { TimeEntry, TimeUser, TimeUserFeatures, WorkDayConfig } from '../../../api/generated/data-contracts';
import { validationRules } from '../../validationRules';
import { ValidateResponse } from '../../Validator';
import { ReportPeriod } from '../../../components/Contexts/GridContext/context';

interface MaxPercentOfCapacityProps {
    timeEntries: TimeEntry[];
    user: TimeUser;
    userReportingPeriod: ReportPeriod;
    userCapacity: number;
    config: TimeUserFeatures;
}

export const MaxPercentOfCapacity = (props: MaxPercentOfCapacityProps): ValidateResponse => {
    const maxPercent = props.config.timeSheetValidation.maxPercentOfCapacity ?? 100;
    let workingDays: Date[] = [];

    function addDays(dateToAdd: Date) {
        const date = new Date(dateToAdd);
        date.setDate(date.getDate() + 1);
        return date;
    }

    function getDates(startDate: Date, endDate: Date) {
        let currentDate: Date = startDate;
        while (currentDate <= endDate) {
            workingDays.push(currentDate);
            currentDate = addDays(currentDate);
        }
    }

    getDates(props.userReportingPeriod.startDate, props.userReportingPeriod.endDate);
    workingDays = workingDays.filter(isWorkDay(props.config.weekConfig));

    const periodAvailability = props.userCapacity;
    const totalCapacity = workingDays.length * periodAvailability;

    const totalReported = MathToFixed(
        props.timeEntries.reduce((sum, current) => sum + current.hours, 0),
        2,
    );

    const percentRegistered = (totalReported / totalCapacity) * 100;

    const valid = percentRegistered <= maxPercent;

    const response: ValidateResponse = {
        reason: !valid ? `You cannot report more than ${maxPercent}% of capacity per period` : null,
        valid: valid,
        name: validationRules.maxPercentOfCapacityEnabled,
        rejected: !valid,
    };

    return response;
};

const isWorkDay = (weekConfig: WorkDayConfig[]) => {
    const enabledDays = new Set(
        weekConfig
            .filter(day => day.enabled)
            .map(day => day.name?.toLowerCase())
            .filter((name): name is string => !!name),
    );

    return (date: Date): boolean => {
        const weekday = date.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
        return enabledDays.has(weekday);
    };
};
